import { sub, parse, add, endOfWeek } from 'date-fns';
import { DateUtils } from 'react-day-picker';
import { toInterfaceDayFormat, INTERFACE_DAY_FORMAT } from 'utils/date';

export const today = new Date();
export const yesterday = sub(today, { days: 1 });
export const lastMonth = sub(today, { months: 1 });
export const nextMonth = add(today, { months: 1 });
export const lastWeek = sub(today, { weeks: 1 });
export const last2Week = sub(today, { weeks: 2 });
export const last3Week = sub(today, { weeks: 3 });
export const weekEnd = endOfWeek(today, { weekStartsOn: 1 });

export const parseDate = (str: string) => {
  const parsed = parse(str, INTERFACE_DAY_FORMAT, new Date());

  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
};

export const formatDate = (date: Date) => {
  return toInterfaceDayFormat(date);
};
